import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=898ce0e0&scoped=true&lang=html&"
import script from "./profile.vue?vue&type=script&lang=js&"
export * from "./profile.vue?vue&type=script&lang=js&"
import style0 from "./profile.vue?vue&type=style&index=0&id=898ce0e0&lang=scss&scoped=true&"
import style1 from "./profile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898ce0e0",
  null
  
)

export default component.exports